import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-transaction',
  templateUrl: './invoice-transaction.component.html',
  styleUrls: ['./invoice-transaction.component.scss']
})
export class InvoiceTransactionComponent implements OnInit {

  static that: InvoiceTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private translate: TranslateService,
  ) {
    InvoiceTransactionComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();

    this.tableDetails = {
      data: [],
      columnDetails: [
        { columnName: 'InvoiceNo', columnNameIsShow: false, dataFieldName: 'InvoiceNumber', dataFieldName2: "InvoiceDate", divType: 'UserDetails' },
        { columnName: 'Invoice Type', columnNameIsShow: false, dataFieldName: 'ChargeType', },
        { columnName: 'Branch', columnNameIsShow: false, dataFieldName: 'BranchName', },
        { columnName: 'Customer', columnNameIsShow: false, dataFieldName: 'CustomerName', },
        { columnName: 'CreditDays', columnNameIsShow: false, dataFieldName: 'CreditDays', color: 'CreditDaysColor', divType: 'salesInvoiceNew' },
        { columnName: 'DueDate', columnNameIsShow: false, dataFieldName: 'InvoiceDueDate', },
        { columnName: 'Amount', columnNameIsShow: false, dataFieldName: 'TotalAmount', },
        { columnName: 'DueAmount', columnNameIsShow: false, dataFieldName: 'BalanceDue', },
        { columnName: 'EInvoice', columnNameIsShow: false, dataFieldName: 'EInvoiceStatus', },
      ],
      isColumnNameShow: true,

    }



  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['Id']) {
    //   this.Id = changes['Id'].currentValue;
    //   if (this.Id) {
    //     this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
    //   }
    // }
  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: "No Records Found",
      data: [],
      columnDetails: [],
      actionList: [],
      isColumnNameShow: true,
    };
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {


    Helpers.setLoading(true);

    if (CompanyId !== undefined && CompanyId !== null) {
      this.CompanyId = CompanyId;
    }

    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.invoiceId = null;

    if (this.parentTypearray.includes('customer') || this.shipmentModetypearray.includes('customer') || this.shipmentModetypearray.includes('general trade') || this.shipmentModetypearray.includes('e-commerce') || this.parentTypearray.includes('manufacturer')) {
      this.payload.customerIdMulti = Id ? Id : this.Id;
    }
    else {
      this.payload.customerIdMulti = null;
    }

    this.payload.tripId = null;
    this.payload.containerNo = null;
    this.payload.fromDate = this.data.FromDate;
    this.payload.toDate = this.data.ToDate;

    this.payload.Financialyear = null;
    this.payload.FilterEInvoice = 'All';
    this.payload.UserIdSTR = this.userId;
    this.payload.isTransporter = null;
    this.payload.isCustomer = null;
    this.payload.start = (pageNo * perPage);
    this.payload.perpage = perPage;
    this.payload.searchValue = searchValue;
    this.payload.status = 'All';
    this.payload.InvoiceTypeId = null;
    this.payload.isEmailsent = null;

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;


    this._appService.Post("Sales", "GetSalesInvoiceListNew", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].RecordCount;
        this.tableDetails.paginationDetails = {
          totalItems: this.totalCount,
          itemsPerPage: perPage,
          currentPage: pageNo + 1
        }
      } else {
        this.totalCount = 0;
      };

      this.tableDetails.data = response;
      this.tableDetails.data.forEach((item) => {
        let btn = '';
        let color = '';

        if (item.BalanceDue !== 0) {
          if (item.DateDifference >= 0) {
            const due = 'Due';
            const days = 'Days';
            btn = `${due} ${item.DateDifference} ${days}`;
            color = '#3367FB';
          }
          else {
            const overdue = 'Expired by';
            const days = 'Days';
            btn = `${overdue} ${Math.abs(item.DateDifference)} ${days}`;
            color = '#F13637';
          }
        } else if (item.InvoiceDate) {
          btn = `Received`;
          color = '#4BB543';
        }
        item.CreditDays = btn;
        item.CreditDaysColor = color;
      });
      // this.assignTableFields(pageNo, perPage, response)
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    this.GetTransactionList('', pageNo - 1, {}, this.noOfPages, this.Id, this.CompanyId);
  }

  onPageNumberChange(noOfPages: any) {
    this.noOfPages = noOfPages;
    this.GetTransactionList("", 0, {}, noOfPages, this.Id, this.CompanyId);
  }

  GetTransactionListDownload() {
    
  }
  // GetTransactionListDownload(
  //   searchValue = this.searchValue,
  //   pageNo: number = 0,
  //   filterObject: any = this.filterObj,
  //   perPage: any = this.noOfPages,
  //   Id
  // ) {
  //   Helpers.setLoading(true);
  //   localStorage.setItem('perPage', perPage);
  //   this.payload.Start = pageNo * perPage;
  //   this.payload.Length = this.totalCount;
  //   this.payload.SearchValue = searchValue;
  //   this.payload.CompanyId = this.CompanyId;
  //   this.payload.FromDate = this.data.FromDate;
  //   this.payload.ToDate = this.data.ToDate;
  //   this.payload.Id = this.Id;
  //   this.payload.ReferenceType = this.referenceType;

  //   this._appService.Post("VehicleMaster", "GetCustomerRates_Download", this.payload).subscribe((response) => {
  //     this.DownloadFile(response);
  //     Helpers.setLoading(false);
  //   },
  //     (error) => {
  //       Helpers.setLoading(false);
  //       this.toastr.error("Error while downloading", error);
  //     }
  //   );
  // }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }


}
